// export const domain = "http://192.168.1.8:9010";
export const domain = "https://backend.fastro.info";
// export const frontend = "http://localhost:3000";
export const frontend = "https://we2connect.org";
export const dollar = "$";
export const withdrawalAddress = "";

const base = `${domain}/api/v17`;

export const endpoint = {
  // Auth
  admin_login: `${base}/admin-login`,
  verify_admin_totp: `${base}/verify-admin-totp`,
  verify_totp: `${base}/verify-totp`,
  signup: `${base}/admin-signup`,

  // Dashboard
  admin_dashboard: `${base}/get-admin-dashboard`,

  // User & Network
  member_list: `${base}/member-details`,
  update_profile: `${base}/change-member-profile-by-user`,
  update_nominee_details: `${base}/update-nominee-details`,
  update_member_max_payout: `${base}/update-member-max-payout`,
  member_withdrawal_permission: `${base}/change-user-permisson`,
  member_trade_permission: `${base}/change-trade-permission`,
  toggle_subadmin_access: `${base}/toggle-subadmin-access`,
  user_dashboard_business_api: `${base}/user-business-dashboard`,
  team_data_api: `${base}/get-member-downline`,
  get_downline_team: `${base}/get-member-downline`,
  get_member_downline_tree: `${base}/get-member-downline-tree`,

  // Fund Management
  get_report_details: `${base}/get-report-details`,
  member_payout_report: `${base}/member-payout-report`,
  withdrawal_approval_from_admin: `${base}/withdrawal-approval-from-admin`,
  member_fund_transfer: `${base}/member-fund-transfer-p2p`,
  get_spon_name: `${base}/member-name-by-cust-id`,

  // Master Config
  get_master_config: `${base}/get-master-data`,
  update_master_config: `${base}/update-master-data`,

  // News & Updates
  get_news_and_updates: `${base}/get-news-and-updates`,
  update_news_and_updates: `${base}/update-news-and-updates`,
  update_news_and_updates_status: `${base}/update-news-and-updates-status`,

  // Trade Pairs
  get_trade_api: `${base}/get-trade-pair`,
  create_trade_pair_api: `${base}/create-trade-pair`,
  update_trade_pair_api: `${base}/update-trade-pair`,
  delete_trade_pair_api: `${base}/delete-trade-pair`,

  // ROI / Income
  get_package_details: `${base}/get-package-details`,
  update_trade_profit: `${base}/update-trade-profit-conditions`,

  // Sub-admin
  get_subadmins: `${base}/getSubAdmin`,
  update_subadmin_permissions: `${base}/assign-sub-menu`,
  toggle_subadmin_status: `${base}/toggle-subadmin-status`,

  // Tickets
  get_user_message: `${base}/get-user-messages`,
  admin_reply: `${base}/admin-reply`,
};
